import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Phone, Smartphone, Mail, MapPin, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useLang } from "@/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-white/10 bg-[#081627] pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo />
            <p className="mt-4 text-muted-foreground max-w-sm text-sm leading-relaxed">{t.footer.tagline}</p>
            <div className="mt-5 inline-flex items-center gap-2 text-xs text-muted-foreground border border-white/10 rounded-full px-3 py-1.5">
              <ShieldCheck className="w-3.5 h-3.5 text-accent" strokeWidth={1.5} /> Un courtier indépendant · BE 0628.614.141
            </div>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">{t.contact.title}</p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2.5"><Phone className="w-4 h-4 text-accent" strokeWidth={1.5} /><a href="tel:+3267870553" className="hover:text-white text-muted-foreground">067/87.05.53</a></li>
              <li className="flex items-center gap-2.5"><Smartphone className="w-4 h-4 text-accent" strokeWidth={1.5} /><a href="tel:+32472195245" className="hover:text-white text-muted-foreground">0472/19.52.45</a></li>
              <li className="flex items-center gap-2.5"><Mail className="w-4 h-4 text-accent" strokeWidth={1.5} /><a href="mailto:i.lease.be@gmail.com" className="hover:text-white text-muted-foreground">i.lease.be@gmail.com</a></li>
              <li className="flex items-start gap-2.5"><MapPin className="w-4 h-4 text-accent mt-0.5" strokeWidth={1.5} /><span className="text-muted-foreground">Rue Charles Jaumotte 29-31<br />1300 Limal</span></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground mb-4">{t.footer.follow}</p>
            <a href="https://www.linkedin.com/in/olivier-toussaint-785419150/" target="_blank" rel="noopener noreferrer"
              data-testid="linkedin-link"
              className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-white border border-white/10 rounded-full px-4 py-2 hover:border-accent transition-colors">
              <Linkedin className="w-4 h-4" strokeWidth={1.5} /> Olivier Toussaint
            </a>
            <div className="mt-6">
              <Link to="/admin/login" data-testid="footer-admin-link" className="text-xs text-muted-foreground/60 hover:text-accent">{t.nav.admin} →</Link>
            </div>
          </div>
        </div>

        <div className="mt-12 rounded-xl border border-amber-500/20 bg-amber-500/5 px-4 py-3.5 text-center">
          <p className="text-[14px] font-bold text-amber-300 uppercase tracking-wide" data-testid="footer-warning">{t.footer.warningBig}</p>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row justify-between items-center gap-3 text-xs text-muted-foreground/60">
          <p>© {new Date().getFullYear()} I-LEASE SRL · {t.footer.rights}</p>
          <div className="flex items-center gap-4">
            <Link to="/mentions-legales" data-testid="footer-legal-link" className="hover:text-accent transition-colors">{t.footer.legal}</Link>
            <span>Depuis 2015 · Belgique</span>
          </div>
        </div>
        <p className="mt-4 text-center text-[10px] text-muted-foreground/40">Conçu par NEO · Emergent</p>
      </div>
    </footer>
  );
};
